













































import {
  computed, defineComponent, inject, PropType, ref
} from '@nuxtjs/composition-api';
import FilterBox from 'components/catalog/Category/Filters/Renderer/FilterBox.vue';
import { SfCheckbox, SfButton } from '@storefront-ui/vue';
import type { Aggregation } from '@wemade-vsf/magento-api';

export default defineComponent({
  components: {
    FilterBox,
    SfCheckbox,
    SfButton
  },
  props: {
    filter: {
      type: Object as PropType<Aggregation>,
      required: true,
    },
    open: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const { isFilterSelected } = inject('UseFiltersProvider');
    const { loadMoreOptions } = inject<{ loadMoreOptions: (attributeCode: string) => Promise<void>}>('UseAggregationProvider', { loadMoreOptions: (code: string) => Promise.resolve() });
    const selected = computed(() => ((id: string, optVal: string) => isFilterSelected(id, optVal)));
    const showMore = ref(false);

    const loadedMore = computed(() => !props.filter.has_more)

    const visibleOptions = computed(() => {
      let options = props.filter.options;
      return showMore.value ? options : options.slice(0, 10);
    })

    const hasMore = computed(() => {
      if (props.filter.has_more) return true;
      if (!props.filter.has_more && (!props.filter.options?.length || props.filter.options.length <= 10)) return false;
      if (!props.filter.has_more && !showMore.value) return true
      return false
    })

    const doLoadMoreOptions = async () => {
      if (!loadedMore.value) {
        await loadMoreOptions(props.filter.attribute_code);
      }
      showMore.value = true;
    }

    return {
      selected,
      hasMore,
      doLoadMoreOptions,
      visibleOptions,
      showMore
    };
  },
});
